// https://stackoverflow.com/questions/9345136/1000000-to-1m-and-1000-to-1k-and-so-on-in-js

/**
 * @description Format large numbers into their shorten version
 * @param {number} number
 * @param {number} significantFigures
 * @returns {string} formattedNumber
 * @example -1_000 -> -1k
 * @example 1_000 -> 1k
 * @example 1_100 -> 1.1k
 * @example -1_100 -> -1.1k
 */

export const formatLargeNumber = (
  number: number,
  significantFigures: number
) => {
  const isNegative = number < 0;
  const positiveNumberValue = Math.abs(number);
  const p = Math.pow;
  let x = ('' + positiveNumberValue).length;

  significantFigures = p(10, significantFigures);
  x -= x % 3;

  const symbol = isNegative ? '-' : '';

  return (
    symbol +
    Math.round((positiveNumberValue * significantFigures) / p(10, x)) /
      significantFigures +
    ' kMGTPE'[x / 3]
  );
};
